module.exports = __webpack_public_path__ + "static/media/FederalElection2025LogoDesktop.7998c252.svg";